import { useMemo } from "react";

/**
 * Checks if an HTML string contains any visible text content.
 * Strips HTML tags and checks for non-whitespace characters.
 */
export function useHasInnerText(html: string): boolean {
  return useMemo(() => {
    if (!html) return false;
    // Strip HTML tags and check for non-whitespace content
    const stripped = html.replace(/<[^>]*>/g, "").trim();
    return stripped.length > 0;
  }, [html]);
}
